import ApexCharts from 'apexcharts';
import chartOptions from './chartsOptions.js';
import { toMoney } from '@/modules/core/utils/formats';
import { useToast } from 'vue-toastification';

export default {
  data: () => ({
    loading: false,
    instance: null,
  }),
  mounted() {
    this.instance = new ApexCharts(this.$refs.chart, chartOptions);
    this.instance.render();
  },
  unmounted() { this.instance.destroy(); },
  methods: {
    async onFilter(filters) {
      this.loading = true;
      try {
        const dataChart = await this.getCharts(filters);
        this.instance.updateOptions({
          chart: { height: dataChart.x.length ? (dataChart.x.length + 3) * 40 : 400 },
          series: [{ data: dataChart.x }],
          xaxis: { categories: dataChart.y },
          dataLabels: {
            formatter: (val) => `${toMoney(val)} (${(val * 100 / (dataChart.total || 1)).toFixed(2)}%)`,
          },
        });
      } catch (error) {
        useToast().error(this.$t('erroAoObterDashboard'));
      }
      this.loading = false;
    },
  },
};
